var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.172,
    height: 33.605,
    viewBox: "0 0 34.172 33.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M34.172,16.8a16.946,16.946,0,0,1-17.086,16.8A16.946,16.946,0,0,1,0,16.8,16.946,16.946,0,0,1,17.086,0,16.946,16.946,0,0,1,34.172,16.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M15.289,22.878H12.04V15.37H10.417V12.783H12.04V11.229c0-2.11.918-3.367,3.521-3.367h2.168V10.45H16.375c-1.014,0-1.082.362-1.082,1.037l0,1.3h2.456l-.288,2.588H15.289v7.508",
    transform: "translate(2.725 1.706)",
    fill: "#0748b1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0df5c163be3b730b37d02da64ce751b3.svg";
export { ForwardRef as ReactComponent };